// extracted by mini-css-extract-plugin
export default {"login-container":"Login_login-container__si7L2","login-carousel":"Login_login-carousel__ZCr0P","login-form":"Login_login-form__qh9nW"};